import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ListProcessosResponse } from '@/features/secretaria-arbitral/types';

import type { ArbitragensGlobaisParams } from '../../types/arbitragensGlobais';

import { arbitragensGlobaisService } from './services';

export const fetchArbitragensGlobais = createAsyncThunk<
  ListProcessosResponse,
  ArbitragensGlobaisParams,
  { rejectValue: string }
>('arbitragensGlobais/fetchList', async (params, { rejectWithValue }) => {
  try {
    return await arbitragensGlobaisService.list(params);
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar as arbitragens',
    );
  }
});
